// removed by extract-text-webpack-plugin
module.exports = {"time-container":"UpcomingTime__time-container___2vYP3"};